import { P2GBox } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

import AlertWithIcon from '../../../AlertWithIcon';

export interface props {
  reset: () => void;
  cancel: () => void;
}

export const MultiConsignmentUnsupported: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  // Interpolated rather than written out again, so the sentence cannot end up naming a label the link
  // below no longer uses.
  const closeLabel = t('CLOSE_LINK', 'Close');

  return (
    <P2GBox mb={2}>
      <AlertWithIcon color="error">
        <P2GText variant="body2">
          <Trans
            t={t}
            i18nKey="MULTI_CONSIGNMENT_UNSUPPORTED_TEXT"
            defaults="<strong>Note:</strong> This service does not support multi-parcel shipments."
          />
          <br />
          {t('MULTI_CONSIGNMENT_UNSUPPORTED_ACTIONS_TEXT', {
            defaultValue:
              "You can send as a single-parcel shipment, or click '{{closeLabel}}' if you want to choose a different service.",
            closeLabel
          })}
        </P2GText>
        <P2GLinkGroup
          pt={1}
          links={[
            <P2GLink onClick={props.reset} key="single">
              {t('SEND_AS_SINGLE_PARCEL_LINK', 'Send as Single Parcel')}
            </P2GLink>,
            <P2GLink onClick={props.cancel} key="close">
              {closeLabel}
            </P2GLink>
          ]}
        />
      </AlertWithIcon>
    </P2GBox>
  );
};
